export const taskTriggersBasicInfoInputs = ['name', 'type', 'taskTemplate', 'nextTaskTemplate']
